(function () {
  const outingEventsTeamsApp = function () {
    const bindDragNDrop = () => {
      const dropTeeGroups = dragula(
        $('.teams-needing-tee-group, .tee-group-container').toArray(),
        {}
      ).on('drop', setTeeGroupTeam);

      window.outingTeeGroupsApp = { dropTeeGroups };
    };

    const setTeeGroupTeam = function (el, target) {
      var value = $(target).hasClass('tee-group-container')
        ? $(target).data('tee-group-id')
        : '';
      $(el).find('.team-input').val(value);
    };

    const autoGenerateTeeGroups = function(e) {
      window.stopEvent(e);

      const ajaxUrl = $(this).attr('href');
      window.swalConfirm.fire({
        text: 'This action will change your current tee groups.'
      }).then(result => {
        if (!result.isConfirmed) return false;

        window.swal.fire({
          title: null,
          text: "How many teams per tee group?",
          input: 'number',
          cancelButtonText: 'Cancel',
          confirmButtonText: 'Auto generate tee groups',
          reverseButtons: true,
          icon: 'info',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-secondary mr-2',
          },
          buttonsStyling: false,
          showConfirmButton: true,
          preConfirm: (result) => {
            if (result && result.length > 0) return (teamsPerTeeGroup = parseInt(result));

            Swal.showValidationMessage('Please enter how many teams per tee group.');
          },
          inputValue: gon.teams_per_tee_group
        }).then((result) => {
          if (!result.isConfirmed) return false;

          $('.generic-loader').removeClass('d-none')
          $.post({
            url: ajaxUrl,
            method: 'POST',
            data: { teams_per_tee_group: teamsPerTeeGroup },
            success: () => window.location.reload(),
          })
        });
      })
    };

    $(document).on('turbolinks:load', () => {
      if (!$('body').hasClass('controller-outings-tee_groups')) return;

      bindDragNDrop();
      $('#auto-generate-tee-groups').on('click', autoGenerateTeeGroups);
    });
  };

  if (typeof window !== 'undefined') {
    window.outingEventsTeamsApp = outingEventsTeamsApp();
  }
})();
